module.exports = __webpack_public_path__ + "static/media/home.bd089d5a.png";